import React from "react";
import PanelWrapperFullWidth from "../../internal/panelWrapperFullWidth/PanelWrapperFullWidth";
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import * as styles from "./FullWidthImagePanel.module.scss";

const FullWidthImagePanel = ({ blok }) => {
  return (
    <PanelWrapperFullWidth blok={blok}>
        {/* Mobile Image */}
        <div className={styles.mobile_img + " " + styles.full_width_img}>
      {blok.mobile_image && blok.mobile_image.filename !== null? (
          <StoryblokImage
            sbImageData={blok.mobile_image}
            cropWidth={1200}
            cropHeight={300}
            smartCrop={true}
          />
      ) : null}
      </div>

      {/* Destop Image */}
      <div className={styles.desktop_img + " " + styles.full_width_img}>
      {blok.desktop_image && blok.desktop_image.filename !== null ? (
          <StoryblokImage sbImageData={blok.desktop_image} />
      ) : blok.mobile_image && blok.mobile_image.filename !== null ? (
          <StoryblokImage
            sbImageData={blok.mobile_image}
            cropWidth={1200}
            smartCrop={true}
          />
      ) : null}
      </div>
    </PanelWrapperFullWidth>
  );
};

export default FullWidthImagePanel;
